import React from "react";
import "./Project.css";
import beautybebo from "./img/beautybebo.png"
import overstock from "./img/overstock.png"
import bestbuy from "./img/bestbuy.png"
function Project() {
  return (
    <div className="project component__space" id="Portfolio">
      <div className="heading">
        <h1 className="heading">My Latest Projects</h1>
      </div>
       <div className="container">
           <div className="row">
             
             <div className="col__3 pro">
                 <div className="project__box pointer relative">
                     <div className="project__box__img pointer relative">
                         <div className="project__img__box">
                             <img src={beautybebo} alt="" className="project__img" />
                         </div>
                     </div>
                     <p className="desc">Beauty Bebo is an E-commerce web application where people can buy different kind of products such as  Makeup, Skin care, Hair care, Personal care, Mom and Baby care, Fragrance and Ayurveda products etc. </p>
                     <div className="buttons">
                     <a href="https://632ab6319747a1361e695906--beauty-bebo-web-clone.netlify.app/" target="_blank" className="project__btn">Demo</a>
                     <a href="https://github.com/Dreamboy-26/BeautyBebo" target="_blank" className="project__btn">Code</a>
                     </div>
                 </div>
             </div>


             <div className="col__3 pro">
                 <div className="project__box pointer relative">
                     <div className="project__box__img pointer relative">
                         <div className="project__img__box">
                             <img src={overstock} alt="" className="project__img" />
                         </div>
                         <div className="mask__effect"></div>
                     </div>
                     <p className="desc">Overstock.com Inc. is an online retailer and technology company offering customers a range of brands for the home including furniture, home decor, area rugs, bedding and bath etc. </p>
                     <div className="buttons">
                     <a href="https://overstock-clone-2.netlify.app" target="_blank" className="project__btn">Demo</a>
                     <a href="https://github.com/Dreamboy-26/overstock-clone"  target="_blank" className="project__btn">Code</a>
                     </div>
                 </div>
             </div>


             <div className="col__3 pro">
                 <div className="project__box pointer relative">
                     <div className="project__box__img pointer relative">
                         <div className="project__img__box">
                             <img src={bestbuy} alt="" className="project__img" />
                         </div>
                         <div className="mask__effect"></div>
                     </div>
                     <p className="desc">Best Buy Co. Inc. is an American multinational consumer electronics retailer headquartered in Richfield, Minnesota. From here people can fulfill the need of electronic items such as computers, cell phones etc. </p>
                     <div className="buttons">
                     <a href="https://best-buy-tawny.vercel.app/" target="_blank" className="project__btn">Demo</a>
                     <a href="https://github.com/Dreamboy-26/Best-Buy" target="_blank" className="project__btn">Code</a>
                     </div>
                 </div>
             </div>
           </div>
       </div>
    </div>
  );
}

export default Project;
